module.exports = __webpack_public_path__ + "static/media/finches2.467ee581.jpg";